import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query';
import type { SyncStatus } from '@/types/api';

/**
 * Invoice-Ninja-Sync-Status für das Settings-Dashboard.
 *
 * Auto-Refresh alle 30s damit "letzter Sync"-Anzeige nicht stale wird, ohne
 * dass User manuell reloaden muss.
 */
export function useSyncStatus(): ReturnType<typeof useQuery<SyncStatus>> {
  return useQuery<SyncStatus>({
    queryKey: queryKeys.invoiceNinja.syncStatus,
    queryFn: () => api.get<SyncStatus>('/sync/invoice-ninja/status'),
    refetchInterval: 30_000,
  });
}

interface TriggerSyncResponse {
  job_id: string;
  status: 'queued' | 'running';
}

export function useTriggerSync(): ReturnType<
  typeof useMutation<TriggerSyncResponse, Error, void>
> {
  const qc = useQueryClient();
  return useMutation<TriggerSyncResponse, Error, void>({
    mutationFn: () => api.post<TriggerSyncResponse>('/sync/invoice-ninja/trigger'),
    onSuccess: () => {
      // Status sofort + nach kurzer Wartezeit refetchen.
      void qc.invalidateQueries({ queryKey: queryKeys.invoiceNinja.syncStatus });
      setTimeout(() => {
        void qc.invalidateQueries({ queryKey: queryKeys.invoiceNinja.syncStatus });
        void qc.invalidateQueries({ queryKey: queryKeys.contracts.all });
      }, 5000);
    },
  });
}
